import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex lg:flex-wrap lg:flex-row flex-col lg:items-center min-h-screen lg:justify-between" }
const _hoisted_2 = { class: "w-full px-4 lg:w-1/2 sm:px-20 lg:py-0 py-6" }
const _hoisted_3 = { class: "sm:max-w-[360px] mx-auto" }
const _hoisted_4 = { class: "mb-6" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "mt-6 text-center" }, [
  /*#__PURE__*/_createElementVNode("a", {
    href: "/login",
    class: "m-0 text-sm transition text-primary-600 hover:text-primary-800"
  }, "Return to Login")
], -1)

import { ref } from "vue";

import {
    IonPage,
    IonContent 
} from '@ionic/vue';
import ButtonComponent from '@/components/buttons/ButtonComponent.vue';
import TextInput from '@/components/inputs/TextInput.vue';
import PageLoader from "@/components/loaders/PageLoader.vue"
import SuccessModal from '@/components/modals/SuccessModal.vue';

import ForgotPassword from '@/classes/ForgotPassword';

import { errorResponse } from "@/helpers/errorMessage";

import { useRoute, useRouter } from 'vue-router';

import AuthLogo from "../Components/AuthLogo.vue";
import AuthTitle from "../Components/AuthTitle.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPassword',
  setup(__props) {


const router = useRouter();
const route = useRoute();

const loading = ref<boolean>(false);
const showSuccess = ref<boolean>(false);
const email = ref<string>('');
const successMessage = ref<string>('');
const errors = ref<any>();

const submit = (): void => { 
    loading.value = true;
    ForgotPassword.instantiate({ email: email.value })
        .then(({ data }) => {
            loading.value = false;
            showSuccess.value = true;
            successMessage.value = data.success;
            // redirect
            // href = "/verification-code"
        }).catch((error) => { 
            loading.value = false;

            errors.value = errorResponse(error.response?.data?.errors)
        });
}

const confirm = (): void => {
    router.replace({ path: 'verification-code', query: { email: email.value } })
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonPage), null, {
    default: _withCtx(() => [
      _createVNode(_unref(IonContent), { fullscreen: true }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(AuthLogo),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(AuthTitle, {
                  title: "Forgot Password",
                  description: "Kindly provide your email address"
                }),
                _createElementVNode("form", {
                  class: "",
                  onSubmit: _withModifiers(submit, ["prevent"])
                }, [
                  _createElementVNode("div", _hoisted_4, [
                    _createVNode(TextInput, {
                      type: "email",
                      label: "Email Address",
                      placeholder: "Email Address",
                      name: "email",
                      id: "email",
                      modelValue: email.value,
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((email).value = $event)),
                      error: errors.value?.email
                    }, null, 8, ["modelValue", "error"])
                  ]),
                  _createVNode(ButtonComponent, {
                    type: "submit",
                    size: "large",
                    btnWidth: "w-full rounded-lg"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Submit ")
                    ]),
                    _: 1
                  }),
                  _hoisted_5
                ], 32)
              ])
            ])
          ]),
          _createVNode(SuccessModal, {
            show: showSuccess.value,
            onConfirm: confirm,
            "action-text": "Close",
            title: "Success!",
            content: successMessage.value
          }, null, 8, ["show", "content"]),
          _createVNode(PageLoader, { show: loading.value }, null, 8, ["show"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})